import { useAuthFlow } from '@/hooks';
import { ArrowLeft, X } from 'lucide-react';
import { PrefetchPageLinks, useNavigate } from 'react-router';

interface ProbabilityEventSecondaryHeaderProps {
	title?: string;
	url?: string;
	state?: any;
	variant?: 'back' | 'close';
}

export function ProbabilityEventSecondaryHeader({
	title = 'In Progress',
	url,
	state,
	variant = 'back',
}: ProbabilityEventSecondaryHeaderProps) {
	const navigate = useNavigate();
	const { isWTN } = useAuthFlow();
	const handleNavigate = () => {
		if (url) {
			navigate(url, { state });
		} else {
			navigate(-1);
		}
	};

	return (
		<>
			{url && <PrefetchPageLinks page={url} />}
			<header
				className="fixed left-0 right-0 top-0 z-50 border-b px-3 border-[#E1E7F1] bg-white text-[#1C2D4A]"
				style={{
					height: isWTN ? '96px' : '54px',
					paddingBottom: isWTN ? '16px' : '0px',
				}}
			>
				<div
					className="mx-auto flex h-full items-center"
					style={{
						alignItems: isWTN ? 'flex-end' : 'center',
					}}
				>
					<div className="w-10 flex-shrink-0">
						{variant === 'back' && (
							<button
								type="button"
								onClick={handleNavigate}
								className="flex h-8 w-8 items-center justify-center text-[#474747]"
								aria-label="Back"
							>
								<ArrowLeft className="h-5 w-5" strokeWidth={2.4} />
							</button>
						)}
					</div>

					<div className="min-w-0 flex-1 text-center">
						{/* Figma Headline/Headline — DM Sans Bold 16 / 22 / -0.6 / #0A0A0A */}
						<p className="truncate font-['DM_Sans'] text-[16px] font-bold leading-[22px] tracking-[-0.6px] text-[#0A0A0A]">
							{title}
						</p>
					</div>

					<div className="flex w-10 flex-shrink-0 justify-end">
						{variant === 'close' && (
							<button
								type="button"
								onClick={handleNavigate}
								className="flex h-8 w-8 items-center justify-center text-[#474747]"
								aria-label="Close"
							>
								<X className="h-5 w-5" strokeWidth={2} />
							</button>
						)}
					</div>
				</div>
			</header>
		</>
	);
}
